import { FormattedMessage } from 'react-intl';
import { Card, CardContent, Grid, List, ListItem } from '@mui/material';
import { CustomListItem } from 'components/common';
import { IListItem } from './types';

const listItems: IListItem[] = [
  { messageId1: 'affordability.maximumFinancingPossible', messageId2: 'common.noDataFound' },
  { messageId1: 'affordability.maximumFinancingAffordability', messageId2: 'common.noDataFound' },
  { messageId1: 'affordability.maximumFinancingFTV', messageId2: 'common.noDataFound' },
  { messageId1: 'affordability.maximumFinancingFTILimit', messageId2: 'common.noDataFound' },
  { messageId1: 'affordability.maximumFinancingUpperLimit', messageId2: 'common.noDataFound' },
  {
    messageId1: 'affordability.maximumFinancingLowerLimit',
    messageId2: 'common.noDataFound',
    sx: { marginBottom: '4.35rem' },
  },
  { messageId1: 'affordability.onsExpenditure', messageId2: 'common.noDataFound' },
  { messageId1: 'affordability.declaredExpenditure', messageId2: 'common.noDataFound' },
];

export const AffordabilityResultsLeftTable = () => (
  <Grid item xs={12} md={6} lg={6}>
    <Card sx={{ minWidth: 275 }}>
      <CardContent className={'px-2 py-4'}>
        <List className={'w-full'}>
          {listItems.map(({ sx, messageId1, messageId2 }, index) => (
            <ListItem sx={sx} key={index}>
              <CustomListItem>
                <FormattedMessage id={messageId1} tagName={'div'} />
                <FormattedMessage id={messageId2} tagName={'div'} />
              </CustomListItem>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  </Grid>
);
